<div class="cards-container">
    <div style="margin: 10px;" *ngFor="let cardData of menuData">
        <mat-card class="example-card" [routerLink]="[cardData.route]">
            <mat-card-header>
            <mat-card-title-group>
                <mat-card-title></mat-card-title>
                <mat-icon class="icon-table">{{cardData.icon}}</mat-icon>                
            </mat-card-title-group>
            </mat-card-header>
            <mat-card-content>
                {{cardData.name}}
            </mat-card-content>
        </mat-card>
    </div>        
</div>